import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  const subscribe = () => {
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setMsg('Enter a valid email.');
      return;
    }
    setMsg('Thank you for subscribing!');
    setEmail('');
    setTimeout(() => setMsg(''), 4000);
  };

  return (
    <footer
      style={{
        background: '#111827',
        color: 'rgba(255,255,255,0.6)',
        fontFamily: 'Montserrat,sans-serif',
      }}
    >
      <div style={{ padding: '60px 0 32px' }}>
        <div className="auto-container">
          <div className="row">
            {/* Col 1 — Brand */}
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-12"
              style={{ marginBottom: 36 }}
            >
              <div style={{ marginBottom: 16 }}>
                <Link to="/">
                  <img
                    src="/images/gw/logo.png"
                    alt="Greatwood Hotel"
                    style={{
                      height: 64,
                      objectFit: 'contain',
                      filter: 'brightness(0) invert(1)',
                      display: 'block',
                    }}
                  />
                </Link>
              </div>
              <p style={{ fontSize: 13, lineHeight: 1.8, marginBottom: 20 }}>
                Greatwood Hotel — a landmark of hospitality excellence on the
                Portharcourt-Owerri Road, Owerri, Imo State. World-class
                accommodation, swimming pool, bar, event hall and boardroom.
              </p>

              {/* Subscribe */}
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: 2,
                    textTransform: 'uppercase',
                    color: '#b08d57',
                    marginBottom: 10,
                  }}
                >
                  Newsletter
                </div>
                <div style={{ display: 'flex' }}>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email address"
                    style={{
                      flex: 1,
                      padding: '10px 14px',
                      background: 'rgba(255,255,255,0.07)',
                      border: '1px solid rgba(255,255,255,0.12)',
                      borderRight: 'none',
                      color: '#fff',
                      fontSize: 13,
                      outline: 'none',
                      fontFamily: 'Montserrat,sans-serif',
                    }}
                  />
                  <button
                    onClick={subscribe}
                    style={{
                      padding: '10px 16px',
                      background: '#b08d57',
                      border: 'none',
                      color: '#fff',
                      cursor: 'pointer',
                      fontSize: 14,
                    }}
                  >
                    <i className="fas fa-paper-plane"></i>
                  </button>
                </div>
                {msg && (
                  <p style={{ fontSize: 12, color: '#b08d57', marginTop: 6 }}>
                    {msg}
                  </p>
                )}
              </div>

              {/* Social */}
              <div style={{ display: 'flex', gap: 8 }}>
                {[
                  ['fab fa-facebook-f', '#'],
                  ['fab fa-instagram', '#'],
                  ['fab fa-whatsapp', 'https://wa.me/2348076988183'],
                  ['fab fa-x-twitter', '#'],
                ].map(([icon, href], i) => (
                  <a
                    key={i}
                    href={href}
                    target={href.startsWith('http') ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    style={{
                      width: 34,
                      height: 34,
                      background: 'rgba(255,255,255,0.07)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'rgba(255,255,255,0.6)',
                      fontSize: 13,
                      textDecoration: 'none',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#b08d57';
                      e.currentTarget.style.color = '#fff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        'rgba(255,255,255,0.07)';
                      e.currentTarget.style.color = 'rgba(255,255,255,0.6)';
                    }}
                  >
                    <i className={icon}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Col 2 — Tariff */}
            <div
              className="col-xl-2 col-lg-2 col-md-6 col-6"
              style={{ marginBottom: 36 }}
            >
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  color: '#b08d57',
                  marginBottom: 18,
                }}
              >
                Room Tariff
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
              >
                {[
                  { name: 'Greatwood Standard', price: '₦40,000' },
                  { name: 'Greatwood Executive', price: '₦50,000' },
                  { name: 'Greatwood Special', price: '₦80,000' },
                  { name: 'Presidential Suite', price: '₦150,000' },
                ].map((r, i) => (
                  <Link key={i} to="/rooms" style={{ textDecoration: 'none' }}>
                    <div
                      style={{
                        fontSize: 13,
                        color: 'rgba(255,255,255,0.65)',
                        marginBottom: 2,
                      }}
                    >
                      {r.name}
                    </div>
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 700,
                        color: '#b08d57',
                      }}
                    >
                      {r.price}
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 400,
                          color: 'rgba(255,255,255,0.35)',
                          marginLeft: 4,
                        }}
                      >
                        /night
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* Col 3 — Links */}
            <div
              className="col-xl-2 col-lg-2 col-md-6 col-6"
              style={{ marginBottom: 36 }}
            >
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  color: '#b08d57',
                  marginBottom: 18,
                }}
              >
                Quick Links
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
              >
                {[
                  ['Home', '/'],
                  ['About Us', '/about'],
                  ['Rooms', '/rooms'],
                  ['Facilities', '/services'],
                  ['FAQ', '/faq'],
                  ['Contact', '/contact'],
                ].map(([label, path], i) => (
                  <Link
                    key={i}
                    to={path}
                    style={{
                      fontSize: 13,
                      color: 'rgba(255,255,255,0.55)',
                      textDecoration: 'none',
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = '#b08d57')
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.color = 'rgba(255,255,255,0.55)')
                    }
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Col 4 — Contact */}
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-12"
              style={{ marginBottom: 36 }}
            >
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: 2,
                  textTransform: 'uppercase',
                  color: '#b08d57',
                  marginBottom: 18,
                }}
              >
                Contact Us
              </div>
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
              >
                <div style={{ display: 'flex', gap: 12 }}>
                  <div
                    style={{
                      width: 36,
                      height: 36,
                      background: 'rgba(176,141,87,0.15)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#b08d57',
                      fontSize: 13,
                      flexShrink: 0,
                    }}
                  >
                    <i className="fas fa-location-dot"></i>
                  </div>
                  <span
                    style={{ fontSize: 13, lineHeight: 1.7, paddingTop: 2 }}
                  >
                    Plot OF/12, Commercial District G, Along PH-Owerri Road
                    (Opposite Duwez Filling Station), Owerri, Imo State
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <div
                    style={{
                      width: 36,
                      height: 36,
                      background: 'rgba(176,141,87,0.15)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#b08d57',
                      fontSize: 13,
                      flexShrink: 0,
                    }}
                  >
                    <i className="fas fa-phone"></i>
                  </div>
                  <div>
                    <a
                      href="tel:+2348076988183"
                      style={{
                        display: 'block',
                        fontSize: 14,
                        fontWeight: 600,
                        color: 'rgba(255,255,255,0.75)',
                        textDecoration: 'none',
                      }}
                    >
                      0807 698 8183
                    </a>
                    <a
                      href="tel:+2348176291933"
                      style={{
                        display: 'block',
                        fontSize: 14,
                        fontWeight: 600,
                        color: 'rgba(255,255,255,0.75)',
                        textDecoration: 'none',
                        marginTop: 4,
                      }}
                    >
                      0817 629 1933
                    </a>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <a
                    href="https://wa.me/2348076988183"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '10px 18px',
                      background: '#25d366',
                      color: '#fff',
                      borderRadius: 3,
                      fontSize: 13,
                      fontWeight: 700,
                      textDecoration: 'none',
                    }}
                  >
                    <i className="fab fa-whatsapp"></i> WhatsApp Us
                  </a>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <div
                    style={{
                      width: 36,
                      height: 36,
                      background: 'rgba(176,141,87,0.15)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#b08d57',
                      fontSize: 13,
                      flexShrink: 0,
                    }}
                  >
                    <i className="fas fa-envelope"></i>
                  </div>
                  <a
                    href="mailto:"
                    style={{
                      fontSize: 13,
                      color: 'rgba(255,255,255,0.55)',
                      textDecoration: 'none',
                    }}
                  ></a>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                  <div
                    style={{
                      width: 36,
                      height: 36,
                      background: 'rgba(176,141,87,0.15)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#b08d57',
                      fontSize: 13,
                      flexShrink: 0,
                    }}
                  >
                    <i className="fas fa-clock"></i>
                  </div>
                  <span style={{ fontSize: 13 }}>
                    Reception open 24 hours, 7 days a week
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        style={{
          borderTop: '1px solid rgba(255,255,255,0.07)',
          padding: '18px 0',
        }}
      >
        <div
          className="auto-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          <p style={{ margin: 0, fontSize: 13 }}>
            © {new Date().getFullYear()}{' '}
            <span style={{ color: '#b08d57', fontWeight: 600 }}>
              Greatwood Hotel Ltd
            </span>
            . All Rights Reserved. Owerri, Imo State.
          </p>
          <div style={{ display: 'flex', gap: 18 }}>
            {[
              ['Privacy Policy', '/'],
              ['Terms', '/'],
              ['Reservations', '/contact'],
            ].map(([l, p], i) => (
              <Link
                key={i}
                to={p}
                style={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.35)',
                  textDecoration: 'none',
                }}
              >
                {l}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
